/**
 * WorkspaceManager — Handles profile updates (recruiter profile, consent),
 * data summary and GDPR data deletion.
 */
import { AppEventType } from './appEvents';
import { nowUtc, } from '@common/clientServerApi';
export class WorkspaceManager {
    constructor(deps) {
        this.deps = deps;
    }
    get cache() { return this.deps.dataCache; }
    get events() { return this.deps.eventEmitter; }
    emitUserDataUpdated(userData) {
        this.cache.updateData({ userData, timestamp: Date.now() });
        const event = { userData, timestamp: new Date() };
        this.events.emit(AppEventType.USERDATA_UPDATED, event);
    }
    async updateConsent() {
        this.deps.ensureAuthenticated();
        try {
            const { userData } = await this.deps.makeApiCallWithRetry(() => this.deps.getApi().updateProfile({
                consentApproved: true,
                consentApprovedDateUtc: nowUtc()
            }));
            this.emitUserDataUpdated(userData);
            return userData;
        }
        catch (error) {
            this.deps.handleError('updateConsent', this.deps.toError(error));
            throw error;
        }
    }
    async updateProfile(profileUpdates) {
        this.deps.ensureAuthenticated();
        try {
            const { userData } = await this.deps.makeApiCallWithRetry(() => this.deps.getApi().updateProfile(profileUpdates));
            this.emitUserDataUpdated(userData);
            return userData;
        }
        catch (error) {
            this.deps.handleError('updateProfile', this.deps.toError(error));
            throw error;
        }
    }
    async getDataSummary() {
        this.deps.ensureAuthenticated();
        try {
            const cached = this.cache.getDataSummary();
            if (cached)
                return cached;
            const result = await this.deps.makeApiCallWithRetry(() => this.deps.getApi().getDataSummary());
            this.cache.setDataSummary(result);
            return result;
        }
        catch (error) {
            this.deps.handleError('getDataSummary', this.deps.toError(error));
            throw error;
        }
    }
    async deleteAllUserData(confirmationPhrase, reason) {
        this.deps.ensureAuthenticated();
        try {
            const result = await this.deps.makeApiCallWithRetry(() => this.deps.getApi().deleteUserData({ confirmationPhrase, reason }));
            this.cache.clear();
            return result;
        }
        catch (error) {
            this.deps.handleError('deleteAllUserData', this.deps.toError(error));
            throw error;
        }
    }
}
